import ProductGallery from "../../ProductGallery";
import { PageMeta, BreadcrumbJsonLd } from "../../../seo";

export default function Retail() {
  return (
    <>
      <PageMeta
        title="零售產品"
        description="貓山王朝零售｜馬來西亞貓山王、黑刺榴槤鮮果、急凍產品零售｜香港直送｜貓山王零售、急凍榴槤零售"
        canonicalPath="/retail"
      />
      <BreadcrumbJsonLd
        items={[
          { name: "首頁", path: "/" },
          { name: "零售產品", path: "/retail" },
        ]}
      />
      <ProductGallery />
    </>
  );
}
